/**
 * „Zu planen" auf der Planer-Startseite (Plan Projekt-Tracking, Etappe 3):
 * beauftragte Projekte ohne Einsatz im Kalender. Ein Tipp startet die Planung
 * dieses Projekts gleich hier — dieselbe Kopfzeile wie aus einer Aufgabe
 * (`/planung?planen=1&projekt=…`), der Tag wird im Kalender gewählt.
 */
import { Link } from "react-router-dom";

import { useProjektPhasen } from "../../hooks/useProjektLage";
import "../../styles/phasen.css";

export default function ZuPlanenLeiste() {
  const { data: phasen } = useProjektPhasen();
  const offen = Object.values(phasen || {})
    .filter((z) => z.phase === "planen")
    .sort((a, b) => a.titel.localeCompare(b.titel, "de"));
  if (offen.length === 0) return null;
  return (
    <nav className="ph-zuplanen" aria-label="Projekte zu planen">
      <span className="ph-zuplanen-titel">Zu planen{offen.length > 1 ? ` (${offen.length})` : ""}</span>
      <div className="ph-zuplanen-liste">
        {offen.map((z) => (
          <Link
            key={z.projekt_id}
            className="ph-zuplanen-chip"
            to={`/planung?planen=1&projekt=${z.projekt_id}${z.kunde_id ? `&kunde=${z.kunde_id}` : ""}`}
            title={z.grund}
          >
            {z.titel || "Projekt"}
          </Link>
        ))}
      </div>
    </nav>
  );
}
